import axios, {AxiosResponse} from 'axios'
import {TransfersReportsQueryResponse} from './_models'
import {Option} from 'react-multi-select-component'
import {Response} from '../../../../../../_metronic/helpers'

const API_URL = process.env.REACT_APP_API_URL + '/api'
const REPORTS_URL = `${API_URL}/kpi/reports`
const TRANSFER_URL = `${API_URL}/transfers`

const getTransferReports = (query: string): Promise<TransfersReportsQueryResponse> => {
  return axios
    .get(`${REPORTS_URL}/transfers?${query}`)
    .then((d: AxiosResponse<TransfersReportsQueryResponse>) => d.data)
}

const getTransferStatus = (): Promise<Option[] | undefined> => {
  return axios
    .get(`${TRANSFER_URL}/statuses?all=1`)
    .then((response: AxiosResponse<Response<Option[]>>) => response.data)
    .then((response: Response<Option[]>) => response.data)
}

const downloadServerFile = async (
  filter: string | undefined
): Promise<{message: string; id: number} | void> => {
  var filterAdjust = filter !== undefined ? `?${filter}` : ''
  const response = await axios({
    url: `${REPORTS_URL}/transfers/export${filterAdjust}`,
    method: 'GET',
    responseType: 'blob',
  })

  const contentType = response.headers['content-type'] ?? ''

  if (contentType.includes('application/json')) {
    const text = await (response.data as Blob).text()
    return JSON.parse(text) as {message: string; id: number}
  }

  const href = URL.createObjectURL(response.data)
  const link = document.createElement('a')
  link.href = href
  link.setAttribute('download', 'Relatorio_transferência.xlsx')
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(href)
}

export {getTransferReports, getTransferStatus, downloadServerFile}
